module.exports = __webpack_public_path__ + "img/nuevoLogo.8b81383e.svg";